import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { IonItem, IonLabel, IonIcon } from "@ionic/angular/standalone";

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    imports: [IonIcon, IonLabel, IonItem, CommonModule],
    standalone: true
})
export class DropdownComponent implements OnChanges, ControlValueAccessor {
  @Input() label: string;
  @Input() options: any[];
  @Input() value: any;
  @Output() changeEmitter = new EventEmitter<string>();
  private _label: any;
  showOptions: boolean = false;
  fillOption: boolean = false;
  propagateChange = (_: any) => { };
  disabled: boolean;
  onTouched: any;

  constructor(public control: NgControl) {
    if (control) control.valueAccessor = this;
  }
  writeValue(value: any): void {
    this.value = value;
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnChanges(changes: any): void {    
    if (changes.value?.currentValue && this.options) {
      const selectedOption = this.options.find(option => (option.idBanco ?? option.id) === changes.value.currentValue);
      if (selectedOption) {
        this.label = selectedOption.descripcion ?? selectedOption.name;
        this.fillOption = true;
      }
    }
    else if (changes.label?.firstChange) {
      this._label = changes.label.currentValue;
      this.label = changes.label.currentValue;
    }

    else if (changes.options?.currentValue) {
      this.label = this._label;
      this.fillOption = false;
    }

    else if (changes.value?.currentValue === "") {
      this.label = "Selecciona un banco";
      this.fillOption = false;
    }
  }

  selectOption(option: any) {
    this.showOptions = false;
    this.label = option.descripcion ?? option.name;
    this.fillOption = true;
    this.value = option.idBanco ?? option.id;
    this.propagateChange(this.value);
    this.changeEmitter.emit(option);
  }
}
